import React, { useEffect, useState } from "react";
//import {notImplemented} from "../../utils";
//import {showWarningToast} from "../../validation/ToastContainer";
import {useHistory} from "react-router-dom";
import { Bell } from 'lucide-react';
import { securedFetch } from "../../auth/authService";
import { VIOLATION_RESULT_API } from "../../vars";
import { INFO_BOXES_REFRESH_EVENT } from "../../info-boxes/InfoBoxes";

const NEW_VIOLATIONS_BASELINE_KEY = "octopus:newViolationsBaselineStartTime";
const NOTIFICATION_REFRESH_INTERVAL = 5000;

const getBaselineStorageKey = (currentUser = {}) => {
    const userKey = currentUser?.username || currentUser?.id || "default";
    return `${NEW_VIOLATIONS_BASELINE_KEY}:${userKey}`;
};

export function NotificationLink({ currentUser = {} }) {
    const history = useHistory();
    const [violationsCount, setViolationsCount] = useState(0);
    const [latestViolationStartTime, setLatestViolationStartTime] = useState(null);
    const baselineStorageKey = getBaselineStorageKey(currentUser);

    // const onClick = (e) => {
    //     //e.preventDefault();
    //     //showWarningToast("It will be Developed soon","Octopus DevTeam-");
    //     //notImplemented();
    // }

    const getLast90DaysStartTime = () => {
        const date = new Date();
        date.setDate(date.getDate() - 90);
        return Math.floor(date.getTime());
    };

    const formatNotificationCount = (count) => {
        if (count < 1000) {
            return String(count);
        }

        const compact = count / 1000;
        const value = compact >= 10
            ? Math.floor(compact)
            : Number(compact.toFixed(1));
        return `${value}k`;
    };

    const handleNotification = () => {
        const startTime = Math.max(
            Number(window.localStorage.getItem(baselineStorageKey)) + 1,
            getLast90DaysStartTime()
        );

        if (violationsCount > 0) {
            if (latestViolationStartTime) {
                window.localStorage.setItem(baselineStorageKey, String(latestViolationStartTime));
            }

            setViolationsCount(0);
        }

        history.push(`/recentviolations?f_startTime=${startTime}&s_startTime=desc&notification=1`);
    };

    useEffect(() => {
        const getRecentViolations = (startTime, pageSize = 1) => {
            return securedFetch(`${VIOLATION_RESULT_API}/recent/page?p_page=0&p_size=${pageSize}&f_realTime=1&f_startTime=${startTime}&s_startTime=desc`)
                .then(response => response.json());
        };

        const loadViolationsCount = async () => {
            try {
                const last90DaysStartTime = getLast90DaysStartTime();
                const savedBaseline = Number(window.localStorage.getItem(baselineStorageKey));

                if (!savedBaseline) {
                    const latestViolations = await getRecentViolations(last90DaysStartTime);
                    const latestStartTime = Number(latestViolations?.page?.[0]?.startTime) || Date.now();
                    window.localStorage.setItem(baselineStorageKey, String(latestStartTime));
                    setViolationsCount(0);
                    setLatestViolationStartTime(null);
                    return;
                }

                const nextStartTime = Math.max(savedBaseline + 1, last90DaysStartTime);
                const newViolations = await getRecentViolations(nextStartTime);
                const count = Number(newViolations?.records) || 0;
                setViolationsCount(count);
                setLatestViolationStartTime(count > 0 ? Number(newViolations?.page?.[0]?.startTime) || null : null);
            } catch (error) {
                setViolationsCount(0);
                setLatestViolationStartTime(null);
            }
        };

        loadViolationsCount();
        const intervalId = setInterval(loadViolationsCount, NOTIFICATION_REFRESH_INTERVAL);
        window.addEventListener(INFO_BOXES_REFRESH_EVENT, loadViolationsCount);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener(INFO_BOXES_REFRESH_EVENT, loadViolationsCount);
        };
    }, [baselineStorageKey]);

    return (
        <button
            className="icon-btn"
            onClick={handleNotification}
            title={violationsCount > 0 ? `Notifications (${formatNotificationCount(violationsCount)})` : "Notifications"}
        >
            <Bell className="btn-icon" />
            {violationsCount > 0 && (
                <span className="badge-dot">{formatNotificationCount(violationsCount)}</span>
            )}
        </button>
    )
}
